module.exports = "<div *ngIf=\"!hideAlertMsg\" [@hideAlertMsg]=\"hideAlertMsg\"\n     class=\"message alert-system alert-message \"\n     [ngClass]=\"{'alert': message, 'alert-success': message.type === 'success', 'alert-danger':  message.type === 'error' }\">\n  <i class=\"fa alert-message-icon\"\n     [ngClass]=\"{'fa alert-message-icon': message, 'fa-check-circle': message.type === 'success', 'fa-exclamation-circle':  message.type === 'error' }\"></i>\n  <span class=\"message\">{{message.text}}</span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/alert/alert.component.html
// module id = ./src/app/core/components/alert/alert.component.html
// module chunks = main